import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class BaseUri extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'base-uri';
    }
    getDirectiveType() {
        return DirectiveType.Document;
    }
}
